import {Injectable} from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {MessageModel} from '../../../api/model/messageModel';
import {MessageConverter} from '../../../api/model/converter/message.converter';
import {MessageDataService} from './messageData.service';

@Injectable()
export class MessageDataServiceAdapter extends AbstractDataServiceDtoAdapter<MessageModel, MessageConverter> {
    constructor(dataService: MessageDataService, converter: MessageConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): MessageModel {
        return new MessageModel();
    }
}
